export const SET_DEAL_CONFIG_DATA = "SET_DEAL_CONFIG_DATA";

const initialState = {
  isDataLoading: true,
  dealConfig: {},
  consultedItems: [],
  informedItems: [],
  consultedItemCustom: [],
  consultedCustom: [],
  informedCustom: [],
  informedItemCustom: [],
  combinedSelectedInformed: [],
  combinedSelectedConsulted: [],
};

export default (state = initialState, action = {}) => {
  if (action.type === SET_DEAL_CONFIG_DATA) {
    return { ...state, ...action.payload };
  }

  return state;
};
